import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';
import {MediaService} from "./services/media.service";
import {Capacitor} from '@capacitor/core';
import {initializeApp} from 'firebase/app';
import {indexedDBLocalPersistence, initializeAuth} from 'firebase/auth';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
      private translateService: TranslateService,
      private media: MediaService
  ) {
    const app = initializeApp(environment.firebase);
    if (Capacitor.isNativePlatform) {
      initializeAuth(app, {
        persistence: indexedDBLocalPersistence
      });
    }
    this.translateService.use(environment.defaultLocale);
    this.translateService.use('ua');
  }

  ngOnInit() {
    /*this.media.getChamp().subscribe(resp => {
      console.log(resp)
    })*/
  }
}
